/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import { UsuarioChangeComponent } from "./usuario-change/usuario-change.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class UsuariosRoutingModule {}

export const usuariosRoutes: any[] = [
    {
        path: 'trocar',
        component: UsuarioChangeComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/usuarios-routing.module.ts
 **/